import { Injectable } from '@angular/core';
import {WorkbenchTool} from "../types";
import {Tag, tagToString} from "@webmate-web-core/shared/types/tag";
import {Observable, Subject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class WorkbenchToolService {
    private registeredTools?: { [toolId: string]: WorkbenchTool };
    private relatedTools: Subject<WorkbenchTool[]> = new Subject<WorkbenchTool[]>();

    public getRelatedTools$(): Observable<WorkbenchTool[]>{
        return this.relatedTools.asObservable();
    }

    public changeRelatedTools(toolTags: Tag[]){
        this.relatedTools.next(this.getToolsForTags(toolTags));
    }

    public clearRelatedTools(){
        this.relatedTools.next([]);
    }

    public registerTool(tool: WorkbenchTool): void {
        if(!this.registeredTools){
            this.registeredTools = {}
        }

        if(this.registeredTools[tool.id]){
            return;
        }

        this.registeredTools[tool.id] = tool;
    }

    public getToolsForTags(tags: Tag[]): WorkbenchTool[]{
        if (!this.registeredTools || !tags) {
            return [];
        }

        // Convert Tags list to list of values e.g. Tool=Screenshot -> screenshot
        const stringTags = tags.map(tag => tagToString(tag)).filter(tag => tag.toLowerCase().startsWith("tool")).map(tag => tag.slice(tag.indexOf("=") + 1, tag.length).toLowerCase());
        return Object.values(this.registeredTools).filter(tool => stringTags.some(toolTag => toolTag === tool.id));
    }
}
